"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 日付関連ユーティリティ
 */

const DATETIME_FORMAT = 'YYYY/MM/DD HH:mm';
const DATETIME_FORMAT_SS = 'YYYY/MM/DD HH:mm:ss';
const DATETIME_FORMAT_JP = 'YYYY年MM月DD日 HH時mm分';
const FORMAT_FOR_CSV = 'YYYY_MM_DD_HHmmss';
const DATE_FORMAT = 'YYYY/MM/DD';

/**
 * YYYY/MM/DD HH:mm形式で現在日時（文字列）を返却する
 */
const getCurrentDateTime = () => {
  return (0, _moment.default)().format(DATETIME_FORMAT);
};

/**
 * YYYY/MM/DD HH:mm:ss形式で現在日時（文字列）を返却する
 */
const getCurrentDateTimeSS = () => {
  return (0, _moment.default)().format(DATETIME_FORMAT_SS);
};

/**
 * YYYY/MM/DD HH:mm形式で１か月前の日時（文字列）を返却する
 */
const getDateTimeBeforeMonth = () => {
  return (0, _moment.default)().subtract(1, 'month').format(DATETIME_FORMAT);
};

/**
 * 現在日時からの（過去の）差をを返却する
 */
const fromNow = function (targetDateTime) {
  let locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ja';
  // 0 to 44 seconds	s	a few seconds ago
  // unset	ss	44 seconds ago
  // 45 to 89 seconds	m	a minute ago
  // 90 seconds to 44 minutes	mm	2 minutes ago ... 44 minutes ago
  // 45 to 89 minutes	h	an hour ago
  // 90 minutes to 21 hours 	hh	2 hours ago ... 21 hours ago
  // 22 to 35 hours	d	a day ago
  // 36 hours to 25 days	dd	2 days ago ... 25 days ago
  // 26 to 45 days	M	a month ago
  // 45 to 319 days	MM	2 months ago ... 10 months ago
  // 320 to 547 days (1.5 years)	y	a year ago
  // 548 days+	yy	2 years ago ... 20 years ago

  const target = (0, _moment.default)(targetDateTime, DATETIME_FORMAT);
  if (target.isValid()) {
    target.locale(locale);
    return target.fromNow().replace(' ago', '');
  }
  return targetDateTime;
};
var _default = exports.default = Object.freeze({
  DATETIME_FORMAT,
  FORMAT_FOR_CSV,
  DATE_FORMAT,
  DATETIME_FORMAT_JP,
  DATETIME_FORMAT_SS,
  getCurrentDateTime,
  getCurrentDateTimeSS,
  getDateTimeBeforeMonth,
  fromNow
});